import { ProgramArticle } from "./../../models/program-article";
import { Component, Inject, OnInit } from "@angular/core";
import { MD_DIALOG_DATA } from "@angular/material";
import { ProgramArticleService } from "../../services/program-article.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-replays-modal",
  templateUrl: "./replays-modal.component.html",
  styleUrls: ["./replays-modal.component.scss"],
})
export class ReplaysModalComponent implements OnInit {
  id: number;
  channelId: number;
  spevId: number;
  contentId: string;
  languageId: number;
  destination: string;
  cocoonId: number;
  isSeeReplay : number;

  // TNT Sports
  productCode: string;
  programId: number;

  programArticles: ProgramArticle[];
  loading: boolean;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    private programArticleService: ProgramArticleService,
    private router: Router
  ) {
    const state = this.router.routerState;
    if (
      state.snapshot["_root"].children["0"].children["0"] &&
      state.snapshot["_root"].children["0"].children["0"].value.params.id
    ) {
      this.id =
        state.snapshot["_root"].children["0"].children["0"].value.params.id;
      this.channelId =
        state.snapshot["_root"].children["0"].children[
          "0"
        ].value.params.channelId;
      this.cocoonId =
        state.snapshot["_root"].children["0"].children[
          "0"
        ].value.params.cocoonId;
    }

    this.spevId = data.spevId;
    this.contentId = data.contentId;
    this.languageId = data.languageId;
    this.destination = data.destination;
    this.productCode = data.productCode;
    this.programId = data.programId;
    this.isSeeReplay = 0;
  }

  ngOnInit() {
    this.getReplays();
  }

  getReplays() {
    this.loading = true;
    this.programArticles = [];
    this.programArticleService
      .getReplays(
        this.spevId,
        this.contentId,
        this.languageId,
        this.productCode,
        this.programId
      )
      .subscribe((programArticles) => {
        if (programArticles && programArticles.length > 0) {
          programArticles.forEach((program) => {
            program.destinations = program.destinations.filter(
              (d) => d.id == this.destination
            );
            if (program.destinations.length > 0) {
              program.destinations[0].value.translations =
                program.destinations[0].value.translations.filter(
                  (t) => t.fieldName === "Title"
                );
            }
            this.programArticles.push(program);
          });
        } else {
          if (this.id) {
            this.programArticleService
              .getProgramArticle(
                this.id,
                this.channelId,
                this.languageId,
                this.cocoonId,
              )
              .subscribe((programArticle) => {
                this.programArticles.push(programArticle);
              });
          }
        }
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/replays-modal/replays-modal.component.ts